const ctrl = require('./product.controller');

const app = angular.module('msi.products.product', [
  require('./description'),
  ctrl.module
]);

const templateUrl = require('./views/product.html');

app.component('ogProduct', {
  bindings: {
    item: '<ogFor',
    onItemLoaded: '&?ogOnItemLoaded',
    onlyItemInShipment: '<?ogOnlyItemInShipment'
  },
  controller: ctrl.name,
  templateUrl: templateUrl
});

const readOnlyTemplateUrl = require('./views/product-read-only.html');

app.component('ogProductReadOnly', {
  bindings: {
    item: '<ogFor'
  },
  controller: ctrl.name,
  templateUrl: readOnlyTemplateUrl
});

module.exports = app.name;
